export interface Treatment {
    id: string;
    gId: string;
    voucherGroupId:string;
    voucherGroupName: string;
    clinicName: string;
    name: string;
    productSourceId: string;
    available: string;
    initial: string;
    unitType: TreatmentUnitType;
    date: string;
    isFlatRate: boolean;
}

/**
 * A factory function that creates Treatment
 */
export function createTreatment(params: Partial<Treatment>) {
    return {} as Treatment;
}

/**
 * Factoría que crea un Treatment con los datos recogidos por la API
 */
export function treatmentFactory(params: any) {
    return {
        id: params.VoucherId,
        gId: params.TicketGID,
        voucherGroupId: params.VoucherGId,
        voucherGroupName: params.VoucherGroupName,
        clinicName: params.VoucherClinicName,
        name: params.VoucherName,
        productSourceId: params.VoucherProductSourceId,
        available: params.VoucherAvailable,
        initial: params.VoucherInitial,
        unitType: params.ProductVoucherUnitClassID,
        date: params.VoucherDate ?? '2022-04-23', //TODO
        isFlatRate: params.isFlatRate,
    } as Treatment;
}

export enum TreatmentUnitType {
    units = 1,
    sessions,
    minutes,
    shots,
}
